import { CustomCodeTypeRequest } from './customdatabyrequesttype.interface';
import { AppData } from '../../models/appdata'
import { Injectable, Inject, Injector } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { APP_BASE_HREF } from '@angular/common';
import { Observable, throwError, of } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { ApiResponseModel } from '../../models/api_response_model';
import { Router } from '@angular/router';


@Injectable()
export class CUstomDataByRequestTypeService {

  private baseUrl: string;
  constructor(private http: HttpClient,private injector: Injector, private router: Router) {
 
  }
  GetCustomDataByRequestedType(SendCustomCodeTypeRequest: CustomCodeTypeRequest) {
    const userDetails = AppData.Instance().UserLoginDetails;
    const authKey = (userDetails && userDetails.AuthGenKEY) ? userDetails.AuthGenKEY : '';
    return this.http.post<ApiResponseModel>(
      `${AppData.GlobalApiUrl}MasterData/GetCustomCodeTypeRequest`,
      SendCustomCodeTypeRequest,
      {
        headers: new HttpHeaders().set('AuthGenKEY', authKey)
      }
    ).pipe(catchError(this.handleError));
  }

  private handleError(error: any) {


    if (error.status === 400) {

      return Promise.reject('Request Failed Due to Bad Request..!');
    }
    else if (error.status === 401) {
      return this.unauthorised();

    }
    else if (error.status === 500) {
      return Promise.reject('Internal Server Error..!');

    }
    else {


      let errMsg = (error.message) ? error.message :
        error.status ? `${error.status} - ${error.statusText}` : 'Server error';
      return Promise.reject(error.message || error);
    }
  }
  unauthorised(): Observable<any> {

    this.router.navigate(['/login']);
    return of({});
  }

}
